<template>
  <div class="test-app">
    <p class="count">
      {{ testProp.a }}
    </p>
    <p class="count prop">
      listActiveItems: {{ listActiveItems.length }}
    </p>
    <p class="count prop">
      testParam: {{ testParam }}
    </p>
    <div
      v-for="(item, index) in listItems"
      :key="item.id"
    >
      <div class="item">
        <p class="name">
          {{ item.name }}
        </p>
        <p>{{ item.prop1.a }}</p>
        <b>{{ item.prop2[0].b + index }}</b>
        <input
          type="text"
          @change="(event) => updateItemExistPropMethod(item, event)"
        >
        <input
          type="text"
          @change="(event) => updateItemNewPropMethod(item, event)"
        >
        <p v-if="item.prop1.text">
          <b>{{ item.prop1.text }}</b>
        </p>
        <button @click="deleteMethod(item.id)">
          Delete
        </button>
        <button @click="updateItemMethod(item)">
          Update
        </button>
        <p v-if="item.newProp">
          <b>New prop created</b>
        </p>
      </div>
    </div>
    <button @click="addMethod">
      Add
    </button>
  </div>
</template>

<script>

export default {
  name: 'TestApp',
  data() {
    return {
      testProp: { a: 0 },
      count: 5,
    };
  },
  computed: {
    listItems() {
      return this.$store.getters['test/getList'];
    },
    listActiveItems() {
      return this.listItems.filter(item => item.isActive);
    },
    testParam() {
      // const a = this.$store.getters['test/getList'].length;

      return 2 + Math.random();
    },
    sumListItemsProp1() {
      return this.$store.getters['test/getList'].reduce((acc, item) => {
        acc += item.prop1.a;

        return acc;
      }, 0);
    },
    allListItemsProp2() {
      let res = [];

      this.$store.getters['test/getList'].forEach(item => {
        res = [...res, ...item.prop2];
      });

      return res.length;
    },
  },
  watch: {
    listItems(items, prev) {
      console.log(items, prev);
      this.testProp = { a: items.length };
    },
    sumListItemsProp1(sum, prevSum) {
      console.log(sum, prevSum);
    },
  },
  created() {
    this.$store.commit('test/setList', [
      {
        id: 1,
        prop1: { a: 2 },
        prop2: [{ b: 3 }],
        isActive: true,
        name: 'abc',
      },
      {
        id: 2,
        prop1: { a: 4 },
        prop2: [{ b: 5 }, { c: 6 }],
        isActive: false,
        name: 'qwe',
      },
    ]);
  },
  mounted() {
    console.log('testApp');
  },
  methods: {
    addMethod() {
      this.$store.commit('test/addListItem', {
        id: this.count,
        prop1: { a: this.count },
        prop2: [{ b: this.count }],
        isActive: true,
        name: `${this.count}-${this.count * 2}`,
      });
      this.count++;
    },
    deleteMethod(id) {
      this.$store.commit('test/deleteListItem', id);
    },
    updateItemMethod(item) {
      this.$store.commit('test/updateListItem', {
        id: item.id,
        updatedData: {
          prop1: { a: 2 + this.count },
          prop2: [{ b: 3 + this.count }],
          isActive: false,
          name: 'updatedName',
        },
      });
      this.count++;
    },
    updateItemExistPropMethod(item, event) {
      this.$store.commit('test/updateListItemExistProp', { id: item.id, propData: { a: this.count, text: event.target.value } });
    },
    updateItemNewPropMethod(item, event) {
      this.$store.commit('test/updateListItemNewProp', { id: item.id, data: { newProp: event.target.value } });
    },
  },
};
</script>

<style scoped lang="less">
.test-app {
  padding: 30px;
  .count {
    font-weight: bold;
    font-size: 30px;
    &.prop {
      font-size: 20px;
    }
  }
  .item {
    border: 1px solid gray;
    margin-bottom: 5px;
    display: inline-block;
    padding: 5px;
    .name {
      font-size: 22px;
    }
    input {
      display: block;
      border: 1px solid #ccc;
      margin-bottom: 5px;
    }
    button {
      padding: 5px;
      background: #ccc;
    }
  }
}
</style>
